"use client";
import { usePageContext } from "@providers/PageProvider";
import styles from "./General.module.scss";
import { get, map } from "lodash";
import { formatPrice } from "@utils/currencyFormatter";
import Button from "@components/common/Button";
import Divider from "@components/common/Divider";
import cx from "classnames";
const View = () => {
  const { pageData } = usePageContext();
  const name = get(pageData, "name");
  const description = get(pageData, "description");
  const price = get(pageData, "price");
  const originalPrice = get(pageData, "originalPrice");
  const buttons = get(pageData, "buttons");
  //
  return (
    <section className={styles.boxContent}>
      <div className={styles.content}>
        <h2 className={cx(styles.title, "eh-title")}>{name}</h2>
        <div className={styles.price}>
          <span className={cx({ [styles.sale]: !!originalPrice })}>
            {formatPrice(price)}
          </span>
          {!!originalPrice && <del>{formatPrice(originalPrice)}</del>}
        </div>
        <p className={cx(styles.description, "paragraph")}>{description}</p>
        {/* TODO Action Here */}
        <div className={styles.actions}>
          {map(buttons, (item, index) => (
            <Button className={styles.btn} key={`btn_${index}`} {...item} />
          ))}
        </div>
      </div>
      <Divider />
      {/* <div className={styles.more}>
        <div className={styles.info}>
          <label>SKU: </label>
          <span>123456789</span>
        </div>
        <div className={styles.info}>
          <label>Categories: </label>
          <span>Bàn Phím Cơ, NuPhy</span>
        </div>
        <div className={styles.info}>
          <label>Tags: </label>
          <span>NuPhy</span>
        </div>
        <div className={styles.info}>
          <label>Chia sẻ: </label>
          <span>fb, tw, email,...</span>
        </div>
      </div> */}
    </section>
  );
};
export default View;
